import * as React from "react";
import DashboardLayout from "../layouts/DashboardLayout";
import EvaluatioTable from "../components/Tables/EvaluationTable";
import { UserAuth } from "../context/AuthContext";

export default function ReportEvaluationPage() {
  const { userData } = UserAuth();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
    if (mounted) {
      if (userData?.role !== "organizer" 
          && userData?.role !== "admin"
          && userData?.role !== "super"
      ) {
        window.location.href = "/unauthorized";
      }
    }
  }, []);
  return (
    <DashboardLayout title="Report Evaluation">
      <EvaluatioTable />
    </DashboardLayout>
  );
}